import { render, staticRenderFns } from "./RecipientsList.vue?vue&type=template&id=1f632c1b&scoped=true&"
import script from "./RecipientsList.vue?vue&type=script&lang=js&"
export * from "./RecipientsList.vue?vue&type=script&lang=js&"
import style0 from "./RecipientsList.vue?vue&type=style&index=0&id=1f632c1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f632c1b",
  null
  
)

export default component.exports